import { render, staticRenderFns } from "./xxtr2.vue?vue&type=template&id=3c276a94&scoped=true&"
import script from "./xxtr2.vue?vue&type=script&lang=js&"
export * from "./xxtr2.vue?vue&type=script&lang=js&"
import style0 from "./xxtr2.vue?vue&type=style&index=0&id=3c276a94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c276a94",
  null
  
)

export default component.exports